import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const withAuth = (WrappedComponent) => {
  return function ProtectedComponent(props) {
    const navigate = useNavigate(); // Get the navigate function for redirecting
    useEffect(() => {
      // Check if the user has a valid token stored in sessionStorage
      const token = sessionStorage.getItem("authToken");

      // If no token found, redirect to the login page
      if (!token) {
        navigate("/");  // Redirect to login if not authenticated
      }
    }, [navigate]);

    // Render the wrapped component if the user is authenticated
    return <WrappedComponent {...props} />;
  };
};

export default withAuth;
